export const SECONDARY = {
  DARK: '#095DB0',
  DEFAULT: '#1976D2',
  LIGHT: '#ACDCE5',
  LIGHTER: '#E0F3F5',
} as const;
